import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmStudentIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmStudentIcon = ({ className, ...props }: EmStudentIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.6775 15.3106H9.3208V18.633C9.3208 19.4666 10.0049 20.142 10.8471 20.142H11.1513C11.9935 20.142 12.6775 19.4666 12.6775 18.633V15.3106Z"
      fill="#C48E6A"
    />
    <path
      d="M15.6971 8.66422H6.30245C5.29011 8.66422 4.46167 9.54765 4.46167 10.6253C4.46167 11.7047 5.29011 12.5864 6.30245 12.5864H15.6954C16.7078 12.5864 17.5362 11.703 17.5362 10.6253C17.5379 9.54765 16.7095 8.66422 15.6971 8.66422Z"
      fill="#C48E6A"
    />
    <path
      d="M10.9998 1.89922C8.00915 1.89922 5.23853 5.09781 5.23853 9.70062C5.23853 14.2794 8.09337 16.543 10.9998 16.543C13.9062 16.543 16.761 14.2794 16.761 9.70062C16.761 5.09781 13.9904 1.89922 10.9998 1.89922Z"
      fill="#E0BB95"
    />
    <path
      d="M8.17425 10.9811C8.64222 10.9811 9.02159 10.5886 9.02159 10.1045C9.02159 9.62042 8.64222 9.22797 8.17425 9.22797C7.70627 9.22797 7.3269 9.62042 7.3269 10.1045C7.3269 10.5886 7.70627 10.9811 8.17425 10.9811Z"
      fill="#5D4037"
    />
    <path
      d="M13.8255 10.9811C14.2935 10.9811 14.6728 10.5886 14.6728 10.1045C14.6728 9.62042 14.2935 9.22797 13.8255 9.22797C13.3575 9.22797 12.9781 9.62042 12.9781 10.1045C12.9781 10.5886 13.3575 10.9811 13.8255 10.9811Z"
      fill="#5D4037"
    />
    <path
      d="M11.6631 11.6944C11.6442 11.6875 11.627 11.6823 11.6081 11.6806H10.393C10.3741 11.6823 10.3552 11.6875 10.338 11.6944C10.228 11.7391 10.1678 11.8525 10.2194 11.9745C10.2709 12.0966 10.5133 12.4369 11.0014 12.4369C11.4895 12.4369 11.7319 12.0948 11.7834 11.9745C11.8333 11.8525 11.7731 11.7391 11.6631 11.6944Z"
      fill="#C48E6A"
    />
    <path
      d="M12.4471 13.0831C11.8988 13.408 10.1045 13.408 9.55789 13.0831C9.24336 12.8958 8.92195 13.1828 9.05258 13.4681C9.18149 13.7483 10.1612 14.3997 11.0068 14.3997C11.8524 14.3997 12.8201 13.7483 12.949 13.4681C13.0779 13.1828 12.7616 12.8958 12.4471 13.0831Z"
      fill="#6D4C41"
    />
    <path
      d="M11.0036 0.864532C11.0019 0.864532 11.0019 0.864532 11.0002 0.864532C10.9985 0.864532 10.9985 0.864532 10.9968 0.864532C3.18677 0.905782 4.78692 9.48234 4.78692 9.48234C4.78692 9.48234 5.13755 10.4019 5.29739 10.8075C5.31974 10.8659 5.40567 10.8591 5.41942 10.7989C5.58614 10.053 6.18599 7.40781 6.48849 6.60344C6.66724 6.12906 7.1588 5.85406 7.65552 5.94516C8.42208 6.08438 9.64067 6.25625 10.9865 6.25625C10.9916 6.25625 10.9968 6.25625 11.0002 6.25625C11.0054 6.25625 11.0105 6.25625 11.014 6.25625C12.358 6.25625 13.5783 6.08438 14.3432 5.94516C14.8416 5.85406 15.3332 6.13078 15.5102 6.60344C15.811 7.40438 16.4074 10.0341 16.5758 10.7903C16.5896 10.8522 16.6755 10.8573 16.6979 10.7989L17.21 9.48063C17.2135 9.48235 18.8119 0.905782 11.0036 0.864532Z"
      fill="#AB872F"
    />
    <path
      d="M17.2134 9.48234C17.2134 9.48234 18.8135 0.905782 11.0036 0.864532C11.0018 0.864532 11.0018 0.864532 11.0001 0.864532C10.9984 0.864532 10.9984 0.864532 10.9967 0.864532C10.8746 0.864532 10.7561 0.86797 10.6392 0.873126C10.4071 0.883439 10.182 0.900626 9.96543 0.926407C9.96371 0.926407 9.96027 0.926407 9.95855 0.926407C9.94308 0.928126 9.92933 0.931564 9.91386 0.933282C3.33964 1.76 4.78511 9.48234 4.78511 9.48234L5.2973 10.8023C5.31964 10.8608 5.40386 10.8556 5.41761 10.7938C5.58605 10.0392 6.18418 7.4061 6.48668 6.60516C6.66543 6.13078 7.15699 5.85578 7.65542 5.94688C8.42199 6.08438 9.64058 6.25625 10.9864 6.25625C10.9915 6.25625 10.9967 6.25625 11.0001 6.25625C11.0053 6.25625 11.0104 6.25625 11.0139 6.25625C12.3579 6.25625 13.5782 6.08438 14.3431 5.94516C14.8415 5.85406 15.3331 6.13078 15.5101 6.60344C15.8126 7.40781 16.4125 10.0581 16.5775 10.8006C16.5912 10.8625 16.6754 10.8677 16.6978 10.8092C16.8593 10.4053 17.2134 9.48234 17.2134 9.48234Z"
      fill="url(#paint0_radial_262_44488)"
    />
    <path
      d="M6.87674 8.71755C7.39065 7.99051 8.55768 7.92176 9.22628 8.46317C9.33284 8.54911 9.47378 8.66942 9.51503 8.80348C9.58378 9.02176 9.37409 9.19192 9.16956 9.14036C9.03893 9.1077 8.9169 9.03723 8.78799 8.9977C8.55253 8.92379 8.38237 8.90317 8.17096 8.90317C7.85815 8.90145 7.65706 8.94098 7.35971 9.0613C7.23768 9.11114 7.13799 9.1902 6.99878 9.13176C6.83893 9.06473 6.78049 8.86192 6.87674 8.71755Z"
      fill="#AB872F"
    />
    <path
      d="M14.7932 9.12999C14.7434 9.10764 14.6952 9.08014 14.6454 9.05952C14.3395 8.93233 14.1659 8.89967 13.8341 8.90139C13.542 8.90311 13.3684 8.94264 13.1398 9.01999C13.0006 9.06811 12.8235 9.18842 12.6688 9.14202C12.442 9.07327 12.4488 8.82577 12.5726 8.66764C12.7204 8.48202 12.9232 8.34108 13.1381 8.24827C13.6365 8.03171 14.2449 8.06264 14.7141 8.3428C14.8671 8.43389 15.0338 8.55936 15.1266 8.71749C15.2607 8.94264 15.0579 9.23827 14.7932 9.12999Z"
      fill="#AB872F"
    />
    <path
      d="M20.0234 9.32938C19.8103 9.32938 19.6367 9.49438 19.6367 9.69719V11.2784C19.6367 11.4813 19.8103 11.6463 20.0234 11.6463C20.2366 11.6463 20.4102 11.4813 20.4102 11.2784V9.69719C20.4102 9.49438 20.2366 9.32938 20.0234 9.32938Z"
      fill="#E8AD00"
    />
    <path
      d="M19.25 9.32939C19.0369 9.32939 18.8633 9.49439 18.8633 9.6972V11.2785C18.8633 11.4813 19.0369 11.6463 19.25 11.6463C19.4631 11.6463 19.6367 11.4813 19.6367 11.2785V9.6972C19.6367 9.49439 19.4631 9.32939 19.25 9.32939Z"
      fill="#E8AD00"
    />
    <path
      d="M19.6367 9.32938C19.4236 9.32938 19.25 9.49438 19.25 9.69719V11.6205C19.25 11.8233 19.4236 11.9883 19.6367 11.9883C19.8498 11.9883 20.0234 11.8233 20.0234 11.6205V9.69719C20.0234 9.49438 19.8498 9.32938 19.6367 9.32938Z"
      fill="#FFCA28"
    />
    <path
      d="M19.6366 9.57002C19.8986 9.57002 20.111 9.36764 20.111 9.11799C20.111 8.86834 19.8986 8.66595 19.6366 8.66595C19.3746 8.66595 19.1622 8.86834 19.1622 9.11799C19.1622 9.36764 19.3746 9.57002 19.6366 9.57002Z"
      fill="#FFCA28"
    />
    <path
      d="M19.6367 9.11282C19.5422 9.11282 19.4648 9.03548 19.4648 8.94095V2.4097C19.4648 2.31517 19.5422 2.23782 19.6367 2.23782C19.7312 2.23782 19.8086 2.31517 19.8086 2.4097V8.94095C19.8086 9.0372 19.7312 9.11282 19.6367 9.11282Z"
      fill="#504F4F"
    />
    <path
      d="M19.9375 2.23093C14.6386 0.898895 11 0.855927 11 0.855927C11 0.855927 7.36141 0.898895 2.0625 2.23093V2.36327C2.0625 2.59186 2.21203 2.79296 2.43031 2.85655C3.06969 3.04561 4.68703 3.46327 5.555 3.63686C5.54125 3.65061 5.36594 3.95827 5.24047 4.24358C5.24047 4.24358 6.63953 5.22671 11.0017 5.66671C15.3639 5.22671 16.8042 4.3639 16.8042 4.3639C16.653 4.0528 16.4966 3.76405 16.4966 3.76405C17.27 3.63686 18.9423 3.06452 19.5817 2.85999C19.7966 2.79124 19.9409 2.59358 19.9409 2.36843V2.23093H19.9375Z"
      fill="url(#paint1_linear_262_44488)"
    />
    <path
      d="M11 0.855927C11 0.855927 7.36141 0.898895 2.0625 2.23093C2.0625 2.23093 8.14859 3.89296 11 3.84311C13.8514 3.89296 19.9375 2.23093 19.9375 2.23093C14.6386 0.898895 11 0.855927 11 0.855927Z"
      fill="url(#paint2_linear_262_44488)"
    />
    <path
      d="M19.9375 2.23093C14.6386 0.898895 11 0.855927 11 0.855927C11 0.855927 7.36141 0.898895 2.0625 2.23093V2.36327C2.0625 2.59186 2.21203 2.79296 2.43031 2.85655C3.06969 3.04561 4.68703 3.49077 5.555 3.66608C5.555 3.66608 5.39 3.93421 5.24047 4.2728C5.24047 4.2728 6.63953 5.22671 11.0017 5.66843C15.3639 5.22843 16.8042 4.36561 16.8042 4.36561C16.653 4.05452 16.4966 3.76577 16.4966 3.76577C17.27 3.63858 18.9423 3.06624 19.5817 2.86171C19.7966 2.79296 19.9409 2.5953 19.9409 2.37015V2.23093H19.9375Z"
      fill="url(#paint3_linear_262_44488)"
      opacity="0.4"
    />
    <path
      d="M19.6796 20.7951C19.6796 18.2841 15.9413 17.093 12.6808 16.8248L11.2027 18.7206C11.1546 18.7825 11.079 18.8203 10.9999 18.8203C10.9208 18.8203 10.8452 18.7842 10.7971 18.7206L9.31551 16.8214C7.50223 16.9606 2.31848 17.6378 2.31848 20.7951V21.3125H19.6779L19.6796 20.7951Z"
      fill="#212121"
    />
    <path
      d="M19.6796 20.7951C19.6796 18.2841 15.9413 17.093 12.6808 16.8248L11.2027 18.7206C11.1546 18.7825 11.079 18.8203 10.9999 18.8203C10.9208 18.8203 10.8452 18.7842 10.7971 18.7206L9.31551 16.8214C7.50223 16.9606 2.31848 17.6378 2.31848 20.7951V21.3125H19.6779L19.6796 20.7951Z"
      fill="url(#paint4_radial_262_44488)"
    />
    <defs>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(11.0002 8.02048) scale(6.50946 7.34397)"
        gradientUnits="userSpaceOnUse"
        id="paint0_radial_262_44488"
        r="1"
      >
        <stop
          offset="0.7945"
          stopColor="#BFA055"
          stopOpacity="0"
        />
        <stop
          offset="1"
          stopColor="#BFA055"
        />
      </radialGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_262_44488"
        x1="11"
        x2="11"
        y1="0.111587"
        y2="5.03417"
      >
        <stop
          offset="0.0032"
          stopColor="#424242"
        />
        <stop
          offset="0.4718"
          stopColor="#353535"
        />
        <stop
          offset="1"
          stopColor="#212121"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_262_44488"
        x1="11"
        x2="11"
        y1="0.140239"
        y2="5.46836"
      >
        <stop
          offset="0.0032"
          stopColor="#616161"
        />
        <stop
          offset="0.3237"
          stopColor="#505050"
        />
        <stop
          offset="0.955"
          stopColor="#242424"
        />
        <stop
          offset="1"
          stopColor="#212121"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_262_44488"
        x1="2.38777"
        x2="19.7176"
        y1="3.26269"
        y2="3.26269"
      >
        <stop
          offset="0.0012"
          stopColor="#BFBEBE"
        />
        <stop
          offset="0.3"
          stopColor="#212121"
          stopOpacity="0"
        />
        <stop
          offset="0.7"
          stopColor="#212121"
          stopOpacity="0"
        />
        <stop
          offset="1"
          stopColor="#BFBEBE"
        />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(10.9999 21.0725) scale(9.30995 4.88493)"
        gradientUnits="userSpaceOnUse"
        id="paint4_radial_262_44488"
        r="1"
      >
        <stop
          offset="0.5981"
          stopColor="#212121"
        />
        <stop
          offset="1"
          stopColor="#616161"
        />
      </radialGradient>
    </defs>
  </svg>
);

export default EmStudentIcon;
